module.exports = __webpack_public_path__ + "static/front-cd1823542740d64d819fd8bc9686934e.jpg";